'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = createAction;

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _constants = require('./constants');

var _apiMigrationFill = require('./api-migration-fill');

var _isomorphicHelpers = require('./isomorphic-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorLoging = function errorLoging(error) {

  var errorString = void 0;

  if (!(0, _isomorphicHelpers.isServerSide)()) {
    errorString = '\n--------------------API error--------------------\n';
  } else {
    errorString = '\n--------------------SSR error--------------------\n';
  }

  if (error.message) {
    if (!error.config || !error.config.url) {
      errorString += 'Stack: ' + error.stack + '\n';
    } else {
      errorString += 'Message: ' + error.message + '\n';
    }
  }

  if (error.response) {
    errorString += 'Code: ' + error.response.status + '\n';
    errorString += 'StatusText: ' + error.response.statusText + '\n';
    errorString += 'Data: ' + error.response.data + '\n';
  } else if (error.request) {
    errorString += 'Code: ' + error.request.code + '\n';
    errorString += 'Errno: ' + error.request.errno + '\n';
  }

  if (error.config) {
    errorString += 'Url: ' + error.config.url + '\n';
    errorString += 'Method: ' + error.config.method + '\n';
  }

  errorString += '-------------------------------------------------\n';

  console.error(errorString); //eslint-disable-line
};

function createAction(_ref) {
  var url = _ref.url,
      method = _ref.method,
      parameters = _ref.parameters,
      data = _ref.data,
      actionType = _ref.actionType,
      actionData = _ref.actionData,
      additionalActionsOnSuccess = _ref.additionalActionsOnSuccess,
      additionalActionsOnFail = _ref.additionalActionsOnFail,
      keyword = _ref.keyword,
      xhrConfig = _ref.xhrConfig,
      auth = _ref.auth,
      headers = _ref.headers,
      callback = _ref.callback;

  var REQUEST = actionType + '_REQUESTED';
  var SUCCESS = actionType + '_RECEIVED';
  var FAILURE = actionType + '_FAILED';
  return function (dispatch) {
    dispatch({ type: REQUEST, actionData: actionData });
    return (0, _api2.default)({ url: url, method: method, params: parameters, data: data, xhrConfig: xhrConfig, auth: auth, headers: headers }).then(function (response) {
      if (additionalActionsOnSuccess && additionalActionsOnSuccess.length) {
        additionalActionsOnSuccess.forEach(function (action) {
          dispatch({
            type: action.type,
            actionData: action.actionData
          });
        });
      }
      dispatch({
        type: SUCCESS,
        actionData: actionData,
        response: keyword ? (0, _apiMigrationFill.checkDataForKey)(response.data, keyword) : response.data
      });
      callback && callback();
      return response.data;
    }).catch(function (error) {
      errorLoging(error);
      if (error && error.response && error.response.status === 401) {
        dispatch({ type: _constants.UNAUTHORIZED });
      }
      if (additionalActionsOnFail && additionalActionsOnFail.length) {
        additionalActionsOnFail.forEach(function (action) {
          dispatch({
            type: action.type,
            actionData: action.actionData
          });
        });
      }
      callback && callback();
      return dispatch({
        type: FAILURE,
        code: error && error.response && error.response.status,
        error: error && error.toString(),
        errorData: error && error.response && error.response.data,
        actionData: actionData
      });
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/action-creator.js
// module id = 1527
// module chunks = 0